import React, { useEffect, useRef, useState } from 'react';
import Shared from '../../Components/Frame/Shared';
import * as rsuite from 'rsuite';
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import axios from 'axios';
import { HiOutlineChatAlt2 } from "react-icons/hi";
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import TaskConversation from '../../Components/Task/TaskConversation';

// گفتگوهای باز، یکجا.
//
// دامنه اش را سرور تعیین می کند: مدیر همه تیم را می بیند، کارشناس فقط
// وظایف خودش را. پس این صفحه برای هر دو نقش یکی است.
//
// اینجا برخلاف داشبورد، گفتگوهایی که خود کاربر آخرین پیامشان را داده هم
// می مانند: داشبورد فهرست کارهای اوست، ولی این صفحه فهرست کامل است و
// آدم باید سوالی را که خودش پرسیده و منتظر جواب است هم بتواند دنبال کند.
// در عوض نوبت هر کدام با یک برچسب معلوم می شود و منتظرهای خودش اول
// می آیند - همان هایی که عدد نشان بالای صفحه می شمارد.
const Index = () => {

    //#region Const
    let navigate = useNavigate();
    const ChatRef = useRef();

    const [Data, setData] = useState([]);
    const [ShowLoading, setShowLoading] = useState(true);
    const [showChat, setShowChat] = useState(false);
    //#endregion

    //#region Methods

    const Bind = () => {
        setShowLoading(true);
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/TaskConversation/GetOpen",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setData(res.data);
                setShowLoading(false);
                //--> نشان نوار بالا باید با همین فهرست بخواند
                General.RefreshChatCount();
            })
            .catch(error => {
                setShowLoading(false);
                if (error.response) {
                    if (error.response.status === 401) {
                        navigate("/UnAuthorize");
                    }
                    else if (error.response.status === 403) {
                        navigate("/AccessDenied");
                    }
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                }
            })
    }

    const OpenChat = (item) => {
        setShowChat(true);
        setTimeout(() => {
            ChatRef.current.Show(item.workTaskId, item.taskTitle);
        }, 300);
    }

    //--> نوبت من است اگر آخرین پیام را من نداده باشم. شناسه کاربر همان جایی
    //--> خوانده می شود که خود گفتگو برای تشخیص پیام های خودی می خواند.
    const CurrentUserId = (localStorage.getItem("UserId") || "").toLowerCase();
    const IsMyTurn = (item) =>
        (item.lastMsgSenderId || "").toLowerCase() !== CurrentUserId;

    //--> منتظرهای خودم اول. ترتیب سرور (تازه ترین پیام بالا) داخل هر گروه
    //--> حفظ می شود، چون sort در جاوااسکریپت پایدار است.
    const Rows = [...Data].sort((a, b) => IsMyTurn(b) - IsMyTurn(a));

    useEffect(() => {
        Bind();
    }, [])
    //#endregion

    return (
        <Shared pageTitle={<><HiOutlineChatAlt2 size={25} /> گفتگوها</>}>

            <div align="left">
                <rsuite.Button appearance="primary" color="green" className='mb-2' onClick={Bind}>
                    بازسازی
                </rsuite.Button>
            </div>
            <rsuite.Divider />

            {
                ShowLoading ?
                    <div style={{ padding: 24, textAlign: 'center' }}>
                        <rsuite.Loader content="در حال دریافت اطلاعات..." />
                    </div>
                    :
                    Rows.length === 0 ?
                        <div style={{ padding: 24, textAlign: 'center', color: '#8c97a3' }}>
                            گفتگوی بازی وجود ندارد
                        </div>
                        :
                        Rows.map(item => (
                            <div key={item.id} className='HandCursor'
                                style={{
                                    borderBottom: '1px solid #e6e9ed',
                                    padding: '12px 4px'
                                }}
                                onClick={() => OpenChat(item)}>
                                <rsuite.Stack justifyContent="space-between" style={{ flexWrap: 'wrap', gap: 6 }}>
                                    <span style={{ fontSize: 14, fontWeight: 500 }}>
                                        {
                                            IsMyTurn(item) ?
                                                <rsuite.Tag color="orange" className='ms-2'>
                                                    نوبت شماست
                                                </rsuite.Tag>
                                                :
                                                null
                                        }
                                        {item.subject}
                                    </span>
                                    <span style={{ fontSize: 11, color: '#8c97a3' }}>
                                        {item.msgCount} پیام
                                    </span>
                                </rsuite.Stack>
                                <div style={{ fontSize: 12, color: '#8c97a3', marginTop: 3 }}>
                                    {item.taskTitle}
                                </div>
                                <div style={{ fontSize: 11, color: '#8c97a3', marginTop: 2 }}>
                                    آخرین پیام: {item.lastMsgSenderName} در {item.lastMsgDate} {item.lastMsgTime}
                                </div>
                            </div>
                        ))
            }

            <rsuite.Drawer
                open={showChat}
                onClose={() => setShowChat(false)}
                placement={isMobile ? 'bottom' : 'right'}
                size={isMobile ? 'full' : 'sm'}
            >
                <rsuite.Drawer.Header>
                    <rsuite.Drawer.Title>گفتگو</rsuite.Drawer.Title>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body>
                    <TaskConversation ref={ChatRef} onChange={Bind}
                        onSent={() => setShowChat(false)} />
                </rsuite.Drawer.Body>
            </rsuite.Drawer>

        </Shared>
    );
}

export default Index;
